import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("shariti_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("shariti_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("shariti_user", JSON.stringify(data));
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("shariti_token", data.token);
    localStorage.setItem("shariti_user", JSON.stringify(data.user));
    if (data.session_id) localStorage.setItem("shariti_session", data.session_id);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    const sid = localStorage.getItem("shariti_session");
    if (sid) { try { await api.post("/sessions/end", { session_id: sid }); } catch (e) { /* ignore */ } }
    localStorage.removeItem("shariti_token");
    localStorage.removeItem("shariti_user");
    localStorage.removeItem("shariti_session");
    setUser(null);
    window.location.href = "/login";
  };

  // Suivi du temps actif : battement toutes les 60 s tant que l'onglet est visible.
  useEffect(() => {
    if (!user) return;
    const sid = localStorage.getItem("shariti_session");
    if (!sid) return;
    const beat = () => {
      if (document.visibilityState !== "visible") return;
      api.post("/sessions/heartbeat", { session_id: sid }).catch(() => {});
    };
    beat();
    const iv = setInterval(beat, 60000);
    const onVis = () => { if (document.visibilityState === "visible") beat(); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); };
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
